<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-form @submit.prevent="update">
        <q-card-section>
          <div class="text-h6">Обновление категории</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input dense v-model="newProjectType.name" label="Имя категории"/>
          <q-input dense v-model="newProjectType.description" type="textarea" label="Описание"/>
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn no-caps flat label="Отмена" color="negative" @click="onDialogCancel"/>
          <q-btn no-caps flat label="Обновить категорию" @click="update" type="submit"/>
        </q-card-actions>
      </q-form>

    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import {useDialogPluginComponent, useQuasar} from 'quasar'
import {useParentProjectTypes, useProjectLabels, useProjectUsers, useSelectProjects} from '../composables/project'
import {
  useAddTask,
  useAddTaskLabels,
  useAddTaskPerformers,
  useDeleteTask,
  useDeleteTasks,
  useTask,
  useTaskTypes
} from '../composables/task'
import {computed, reactive, ref, toRefs, watch} from 'vue'
import {requiredRule, notEmptyRule} from "../util/rules";
import {NewTask} from '../models/task';
import {useDayJs} from '../composables/dayjs';
import {useRouteParams} from '@vueuse/router';
import {useRouter} from 'vue-router';
import {usePerformTask, useUpdatePerformTask} from '../composables/performTask';
import {UpdatePerformTask} from '../models/performTask';
import {useEventBus} from '@vueuse/core';
import {taskKey} from '../util/events';
import {NewProjectType, ProjectType, UpdateProjectType} from "../models/project";
import {useProjectTypesStore} from "../store/projectTypes";
const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])
const props = defineProps<{
  projectType: ProjectType,
}>()

const store = useProjectTypesStore()
const {data: projectTypes, isFetching} = useParentProjectTypes()


const newProjectType: UpdateProjectType = reactive({
  name: props.projectType.name,
  description: props.projectType.description,
  parentId: null
})


async function update() {
  await store.updateType(props.projectType.id, newProjectType)
  onDialogOK()
}



</script>